<!-- 
	视频组件 Z06
	1、视频设置：视频链接地址、是否自定义封面：0 不自定义视频封面  1 自定义视频封面、视频封面地址
	2、视频内边距设置：上边距、下边距、左边距、右边距
-->
<template style="position: relative;z-index: 1;">
	<!-- <view class="component-wrapper" :style="wrapperStyle" style="position: relative;z-index: 1;">
		<video style="width: 100%;position: relative;z-index: 1;" :poster="data.imgSource == '1' ? '' : getImageUrl(data.imgUrl)" :src="getImageUrl(data.videoUrl)"
			controls="controls">
		</video>
	</view> -->
	<DomVideoPlayer
	  ref="domVideoPlayer"
	  :src="getImageUrl(data.videoUrl)"
	  :poster="data.imgSource == '1' ? '' : getImageUrl(data.imgUrl)"
	  loop
	  controls
	  muted
	/>
</template>

<script setup>
	import DomVideoPlayer from 'uniapp-video-player'
	import {fnImgRequestPath} from "@/utils/utils";
	import { getCurrentInstance, reactive, ref, computed} from "vue";
	const { ctx } = getCurrentInstance(); //获取上下文实例，ctx=vue2的this
	const props = defineProps({
		componentId: {
			type: String,
			default: ''
		},
		data: {
			type: Object,
			default () {
				return {
					//视频链接地址
					"videoUrl": {
						type: String,
						default: ''
					},
					// 是否自定义封面：封面来源（1原视频图    2手动上传）
					"imgSource": {
						type: String,
						default: '1'
					},
					//视频封面地址
					"imgUrl": {
						type: String,
						default: ''
					}
				}
			}
		}
	})
	
	
	/**
	 * 组件样式
	 */
	const wrapperStyle = computed(() => {
		//预留，后期设置间距
		const paddingPx = 0;
		return `
			line-height: 0;
			padding-top: ${paddingPx}px;
			padding-bottom: ${paddingPx}px;
			padding-left: ${paddingPx}px;
			padding-right: ${paddingPx}px;
		`;
	});
	
	/**
	 * 获取图片地址
	 */
	function getImageUrl(imgUrl){
		return fnImgRequestPath(imgUrl);
	}
	
</script>

<style lang="less" scoped>

</style>
